import { darken, lighten } from "polished";
import styled from "styled-components";
import theme from "@/utils/Theme";

const { colors } = theme;

const Button = ({
  children,
  color,
  onClick,
  disabled,
  className,
  $fullwidth = false,
  type,
  $small = false,
  $inverted = false,
  $isBold = false,
  as = "button",
  ...props
}) => {
  const validColors = Object.keys(colors);
  const buttonColor = validColors.includes(color) ? color : "blue";

  return (
    <StyledButton
      as={as}
      className={className}
      color={buttonColor}
      onClick={onClick}
      disabled={disabled}
      $fullwidth={+$fullwidth}
      type={type || "button"}
      $small={+$small}
      $inverted={+$inverted}
      {...props}
      $isBold={$isBold}
    >
      {children}
    </StyledButton>
  );
};

export default Button;

const StyledButton = styled.button.attrs({
  className: "Button",
})`
  &:first-letter {
    text-transform: uppercase;
  }
  white-space: nowrap;
  font-size: ${({ $small }) => ($small ? "14px" : "22px")};
  @media only screen and (max-width: 500px) {
    font-size: ${({ $small }) => ($small ? "12px" : "20px")};
  }
  @media only screen and (max-width: 400px) {
    font-size: ${({ $small }) => ($small ? "10px" : "18px")};
  }

  height: ${({ $small }) => ($small ? "38px" : "60px")};
  padding: ${({ $small }) => ($small ? "0 20px" : "0 16px")};
  border: ${(props) =>
      props.disabled ? props.theme.colors.dark : props.$small ? "1px" : "2px"}
    solid ${(props) => props.theme.colors[props.color]};
  font-weight: ${({ $small, isBold }) =>
    isBold ? "bold" : $small ? 700 : 900};
  ${(props) => props.theme.colors[props.color]};
  color: ${(props) =>
    props.disabled
      ? props.theme.colors.dark
      : props.$inverted
      ? props.theme.colors[props.color]
      : props.theme.colors.white};
  background-color: ${(props) =>
    props.disabled
      ? props.theme.colors.grey
      : props.$inverted
      ? props.theme.colors.white
      : props.theme.colors[props.color]};
  margin-left: 0;
  margin-right: 0;
  border-radius: 4px;
  margin-bottom: 0;
  text-transform: uppercase;
  margin-bottom: 0;
  display: inline-flex;
  transition: all 0.1s ease-in-out;
  width: ${({ $fullwidth }) => ($fullwidth ? "100%;" : "auto;")};
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: ${(props) =>
      props.$inverted
        ? props.theme.colors[props.color]
        : darken(0.05, props.theme.colors[props.color])};
    color: ${(props) =>
      props.$inverted
        ? props.theme.colors.white
        : darken(0.05, props.theme.colors.white)};
  }
  &:disabled,
  &[disabled] {
    cursor: not-allowed;
  }
  &:disabled:hover,
  &[disabled]:hover {
    background-color: ${(props) => props.theme.colors.greyDark};
    color: ${(props) => props.theme.colors.dark};
  }
  &:active {
    transform: translateY(2px);
    transform: translateX(1px);
    background-color: ${(props) =>
      props.$inverted
        ? props.theme.colors[props.color]
        : lighten(0.02, props.theme.colors[props.color])};
    color: ${(props) =>
      props.$inverted
        ? props.theme.colors.white
        : lighten(0.02, props.theme.colors.white)};
  }
`;
